import React, {Component, PropTypes} from 'react';

import BasicLayout from 'layouts/Basic';
// import UsersList from 'components/users/List'
import UsersDataGrid from 'components/users/DataGrid'
import UsersIndepth from 'components/users/Indepth'
import UsersControls from 'components/users/Controls'

const Page = props => {
  return (
    <BasicLayout
      hero={props.selected && <UsersIndepth {...props} />}
      // main={<UsersList {...props} />}
      main={<UsersDataGrid {...props} />}
      aside={<UsersControls {...props} />}
    />
  );
};

import {toggleUserApproved} from 'actions/index'

import {resource} from 'utils/resourcerizer';
import {USERS_NS} from 'constants/index';

import {connect} from 'react-redux';

const mstp = undefined

const mdtp = dispatch => ({
  toggleUserApproved: (id) => () => dispatch(toggleUserApproved(id))
})

Page.Container = resource(USERS_NS)(connect(mstp,mdtp)(Page));

export default Page;



// WEBPACK FOOTER //
// ./src/components/users/Page.jsx